import {
    ACTIVE_SCREEN_KEY,
    getScreenData,
    removeAllScreenMessages,
    setScreenData,
    showDrawer,
    Store,
} from 'cw-ui-core';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import App from 'src/app/App';
import { NOTIFICATIONS_DRAWER } from 'src/features/notifications/constants';
import { fetchNotificationUtils } from 'src/features/notifications/utils';
import { doUserHaveFullUserManagmentAccess, toMap, checkUserForFullAuthorization } from 'src/util/Util';
import IMPORTED_USERS from 'src/features/users/components/ImportedUsers/Constants';
import { getCurrentUserId, getOriginPartnerId } from 'src/services/ApiService';
import initializeApp from 'src/services/AppService';
// import 'src/components/ShellConnector';
import { getSubscribers } from 'src/features/subscribers/sagas/subscribersSaga.js';

const mapStateToProps = state => {
    // Added for Vodafone use case
    const originPartnerId = getOriginPartnerId();
    const currentUserId = getCurrentUserId();

    const partnerOptInStatus = toMap(getScreenData(state.screen, ['partnerOptInStatus']));
    const importedUsersCount = getScreenData(state.screen, ['importedUsersCount']);

    const appInitialized = getScreenData(state.screen, ['appInitialized']);
    const notificationCount = getScreenData(state.screen, ['notificationCount'], ACTIVE_SCREEN_KEY);
    const shouldShowSubscribers = state.subscribers.subscribers.rows.length > 0 && checkUserForFullAuthorization();

    return {
        isAuthorized: doUserHaveFullUserManagmentAccess(),
        appInitialized,
        currentUserId,
        showApplicationRoleManagementTab: !isEmpty(partnerOptInStatus),
        numberOfUsersNeedingApproval: importedUsersCount || 0,
        originPartnerId,
        notificationCount: notificationCount || 0,
        shouldShowSubscribers,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onDidMount: async () => {
            await Store().runSaga(initializeApp, dispatch);
            await Store().runSaga(getSubscribers).toPromise();
            fetchNotificationUtils();
        },
        onNavigate: () => {
            dispatch(removeAllScreenMessages());
            dispatch(setScreenData(['selectedIds'], {}));
        },
        openNotifications: () => {
            dispatch(showDrawer(NOTIFICATIONS_DRAWER));
        },
        onUsersApprovalButtonClick: () => {
            dispatch(showDrawer(IMPORTED_USERS));
        },
    };
};

const AppContainer = connect(mapStateToProps, mapDispatchToProps)(App);

export default AppContainer;
